import { create } from 'zustand';

export const useAppStore = create((set) => ({
  appLoading: true,
  setAppLoading: (state) => set({ appLoading: state }),

  loading: false,
  setLoading: (state) => set({ loading: state }),
}));
